import { View } from "react-native-web";
import { useResponsive } from '../../hooks/useResponsive';
import { typography, spacing, colors } from "../../utils/styling";

const RainbowText = ({ text }: { text: string }) => {
  const { isMobile } = useResponsive();
  return (
    <span style={{
      margin: 0,
      fontSize: isMobile ? 48 : 120,
      fontWeight: '300',
      fontFamily: typography.fontFamily.body,
      backgroundImage: "linear-gradient(to right, #00A4EF 0%, #9933FF 28%, #FF00FF 54%, #00B3C2 78%, #00FF33 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      display: "inline-block",
    }}>
      {text}
    </span>
  );
};

export default function Redirect() {
  const { isMobile } = useResponsive();
  return(
    <View style={{ 
      width: '100%', 
      display: "flex",
      flexDirection: "row",
      justifyContent: 'center',
      padding: isMobile ? spacing.md : spacing.xl,
      paddingLeft: isMobile ? spacing.lg : spacing.xxl, 
      paddingRight: isMobile ? spacing.lg : spacing.xxl, 
      marginBottom: spacing.xxl,
      background: 'none',
    }}>
      <View
        style={{
          backgroundColor: colors.white,
          borderRadius: 16,
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          padding: isMobile ? spacing.md : spacing.xl,
          width: "100%",
          margin: '40px 0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          border: `1.5px solid #e5e7eb`,
          textAlign: 'center',
        }}
      >
        <h1 style={{margin: 0, fontFamily: "Nunito", fontWeight: 700, fontSize: isMobile ? 48 : 120}}>
          You can now <RainbowText text="redirect"/> back to the <RainbowText text="previous tab"/>
        </h1>
      </View>
    </View>
  );
}